import React from "react";
import { Input, Label } from "reactstrap";

import { map } from "lodash";
import { channels, vehicleTypeList } from "../../../../helper/constants";
import { vehicleTypeFormatter } from "../../../../helper/functions";
import CurrencyFormat from "react-currency-format";

const OffertForm = ({
  offert,
  onChangeOffert,
  handleVehicleType,
  getModels,
  brands,
  models
}) => {

  const handleChangeBrand = (e) => {
    onChangeOffert({ ...offert, brand: e.target.options[e.target.options.selectedIndex].label }, 'brand');
    onChangeOffert({ ...offert, brandId: e.target.value }, 'brandId');
    getModels(vehicleTypeFormatter(offert.vehicleType), e.target.value, (modelsCache) => {
      onChangeOffert({ ...offert, modelsCache }, 'modelsCache');
    });
  }

  return (
    <div className="crm-adjudge-form-container">
      <div className="crm-modal-adjudge-form-group">
        <div className="crm-modal-input-group">
          <Label>Tipo Vehículo</Label>
          <Input
            className='crm-modal-input-text'
            type='select'
            value={offert.vehicleType}
            onChange={(e) => {
              handleVehicleType(offert, e.target.value, 'vehicleType')
            }}
            required
            disabled={models.loading || brands.loading}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(vehicleTypeList, (e, index) => (
              <option key={`${e.id} ${index}`} value={e.value}>
                {e.label}
              </option>
            ))}
          </Input>
        </div>
        <div className="crm-modal-input-group">
          <Label htmlFor='brand'>Marca</Label>
          <Input
            className='crm-modal-input-text'
            id='brand'
            type='select'
            value={offert.brandId}
            onChange={handleChangeBrand}
            required
            disabled={!offert.vehicleType || brands.loading}
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(brands.data, (e, index) => (
              <option key={`${e.VemCodigoMarca}-${index}`} value={e.VemCodigoMarca}>
                {e.VeMNombre}
              </option>
            ))}
          </Input>
        </div>
        <div className="crm-modal-input-group">
          <Label>Modelo</Label>
          <Input
            className='crm-modal-input-text'
            type='select'
            value={offert.model}
            onChange={(e) => onChangeOffert({ ...offert, model: e.target.value }, 'model')}
            disabled={!offert.brand || models.loading}
            required
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(offert.modelsCache, (e, index) => (
              <option key={`${e.VMoCodigoModelo}-${index}`} value={e.VMoModelo}>
                {e.VMoModelo}
              </option>
            ))}
          </Input>
        </div>
        <div className="crm-modal-input-group">
          <Label>Año</Label>
          <Input
            className='crm-modal-input-text'
            name='year'
            id='year'
            type='text'
            value={offert.year}
            onChange={(e) => onChangeOffert({ ...offert, year: e.target.value }, 'year')}
            required
            maxLength='4'
          // disabled={managementCreated.loading}
          />
        </div>
      </div>
      <div className="crm-modal-adjudge-form-group">
        <div className="crm-modal-input-group">
          <Label>Versión</Label>
          <Input
            className='crm-modal-input-text'
            name='version'
            id='version'
            type='text'
            value={offert.version}
            onChange={(e) => onChangeOffert({ ...offert, version: e.target.value }, 'version')}
          // disabled={managementCreated.loading}
          />
        </div>
        <div className="crm-modal-input-group">
          <Label>Precio Vehículo</Label>
          <CurrencyFormat
            className='crm-modal-input-text'
            name='vehicle-price'
            id='vehicle-price'
            value={offert.vehiclePrice}
            onChange={(e) => onChangeOffert({ ...offert, vehiclePrice: e.target.value.replace(/[^,0-9\s]/gi, '') }, 'vehiclePrice')}
            decimalSeparator=","
            thousandSeparator="."
            prefix={"$"}
            customInput={Input}
            required
          />
        </div>
        <div className="crm-modal-input-group">
          <Label>Kilometraje</Label>
          <Input
            className='crm-modal-input-text'
            name='mileage'
            id='mileage'
            type='text'
            value={offert.kilometers}
            onChange={(e) => onChangeOffert({ ...offert, kilometers: e.target.value }, 'kilometers')}
          // disabled={managementCreated.loading}
          />
        </div>
        <div className="crm-modal-input-group">
          <Label>Canal Auto</Label>
          <Input
            className='crm-modal-input-text'
            type='select'
            value={offert.carChannel}
            onChange={(e) => onChangeOffert({ ...offert, carChannel: e.target.value }, 'carChannel')}
            required
          >
            <option key='select' value=''>
              Seleccione
            </option>
            {map(channels, (e, index) => (
              <option key={`${e.id}-${index}`} value={e.label}>
                {e.label}
              </option>
            ))}
          </Input>
        </div>
      </div>
      <div className="crm-modal-form-group-textarea">
        <div className="crm-modal-input-group">
          <Label>Descripción</Label>
          <Input
            className='crm-modal-input-textarea'
            name='description'
            id='description'
            type='textarea'
            value={offert.comment}
            onChange={(e) => onChangeOffert({ ...offert, comment: e.target.value }, 'comment')}
            // disabled={managementCreated.loading}
            maxLength='300'
          />
        </div>
      </div>
    </div>
  );
};

export default OffertForm;